"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var reducer_exports = {};
__export(reducer_exports, {
  blockReducer: () => blockReducer,
  cardReducer: () => cardReducer,
  contentReducer: () => contentReducer,
  dynamicGridReducer: () => dynamicGridReducer,
  dynamicImageReducer: () => dynamicImageReducer,
  dynamicValueReducer: () => dynamicValueReducer,
  fieldReducer: () => fieldReducer,
  formReducer: () => formReducer,
  formStateDocument: () => formStateDocument,
  fullWidthReducer: () => fullWidthReducer,
  gridReducer: () => gridReducer,
  pageReducer: () => pageReducer,
  primarySurveyorFieldReducer: () => primarySurveyorFieldReducer,
  primaryTeamFieldReducer: () => primaryTeamFieldReducer,
  repeatReducer: () => repeatReducer,
  requireRoleReducer: () => requireRoleReducer,
  scopeReducer: () => scopeReducer,
  textReducer: () => textReducer,
  visibilityReducer: () => visibilityReducer
});
module.exports = __toCommonJS(reducer_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_fp = require("@cartographerio/fp");
var import_guard = require("@cartographerio/guard");
var import_util = require("@cartographerio/util");
var import_run = require("../expr/run.js");
var import_guard2 = require("../guard.js");
var import_run2 = require("../rule/run.js");
var import_image = require("./image.js");
var import_initial = require("./initial.js");
var import_message = require("./message.js");
var import_lodash = require("lodash");
var import_types = require("@cartographerio/types");
function fieldReducer(state, parentEnv, action) {
  const { field } = state;
  switch (action.type) {
    case "Reset":
    case "Change": {
      const env = parentEnv.focus(field.path);
      const value = env.getFocused();
      const image = (0, import_image.fieldImage)(field, value);
      const messages = (0, import_run2.runRules)(field, env);
      const counts = (0, import_message.messageCounts)(messages);
      const highlight = (0, import_message.messageHighlight)(counts);
      const visible = (0, import_run.optTopoEval)(field.visible, parentEnv).getOrUndefined() ?? true;
      return {
        ...state,
        value,
        image,
        messages,
        highlight,
        visible,
        ...counts
      };
    }
    case "Insert":
    case "Delete":
      return state;
    default:
      return (0, import_util.checkExhausted)(action);
  }
}
function passThroughChildReducer() {
  return (state, parentEnv, action) => ({
    ...state,
    childState: blockReducer(state.childState, parentEnv, action)
  });
}
const cardReducer = passThroughChildReducer();
function dynamicValueReducer(state, parentEnv, _action) {
  const { block } = state;
  return {
    ...state,
    attribute: (0, import_run.topoEval)(block.value, parentEnv).map((value) => ({
      label: block.label,
      valueType: block.valueType,
      units: block.units,
      decimalPlaces: block.decimalPlaces,
      value,
      error: null
    })).getOrElse((message) => ({
      label: block.label,
      valueType: block.valueType,
      units: block.units,
      decimalPlaces: block.decimalPlaces,
      value: null,
      error: String(message)
    }))
  };
}
function dynamicGridReducer(state, parentEnv, _action) {
  const { block } = state;
  return {
    ...state,
    attributes: block.attributes.map(
      (attribute) => (0, import_run.topoEval)(attribute.value, parentEnv).map((value) => ({
        label: attribute.label,
        valueType: attribute.valueType,
        units: attribute.units,
        decimalPlaces: attribute.decimalPlaces,
        value,
        error: null
      })).getOrElse((message) => ({
        label: attribute.label,
        valueType: attribute.valueType,
        units: attribute.units,
        decimalPlaces: attribute.decimalPlaces,
        value: null,
        error: String(message)
      }))
    )
  };
}
function dynamicImageReducer(state, parentEnv, _action) {
  const urlResult = (0, import_run.topoEval)(state.block.url, parentEnv).mapError(String);
  const captionResult = (0, import_run.optTopoEval)(state.block.caption, parentEnv).mapError(
    String
  );
  return {
    ...state,
    url: urlResult.getOrNull(),
    urlError: urlResult.swap().getOrNull(),
    caption: captionResult.getOrNull(),
    captionError: captionResult?.swap().getOrNull()
  };
}
const fullWidthReducer = passThroughChildReducer();
function gridReducer(state, parentEnv, action) {
  return {
    ...state,
    blockStates: state.blockStates.map((bs) => blockReducer(bs, parentEnv, action))
  };
}
function repeatReducer(state, parentEnv, action) {
  const { block, childStates, arraySchema } = state;
  const arrayEnv = parentEnv.focus(block.path);
  switch (action.type) {
    case "Reset":
    case "Change": {
      return {
        ...state,
        childStates: childStates.map((child, index) => blockReducer(child, arrayEnv.focus([index]), action))
      };
    }
    case "Insert":
    case "Delete":
      return (0, import_initial.initialRepeatStateFromArray)(block, arraySchema, arrayEnv);
    default:
      return (0, import_util.checkExhausted)(action);
  }
}
const requireRoleReducer = passThroughChildReducer();
function textReducer(state, parentEnv, _action) {
  return {
    ...state,
    visible: (0, import_run.optTopoEval)(state.block.visible, parentEnv).getOrUndefined() ?? true
  };
}
function scopeReducer(state, parentEnv, action) {
  return {
    ...state,
    childState: blockReducer(state.childState, parentEnv.focus(state.block.path), action)
  };
}
function visibilityReducer(state, parentEnv, action) {
  return {
    ...state,
    visible: (0, import_run.topoEval)(state.block.visible, parentEnv).getOrUndefined() ?? true,
    childState: blockReducer(state.childState, parentEnv, action)
  };
}
function primarySurveyorFieldReducer(state, parentEnv, action) {
  if (action.type === "Change" && ((0, import_lodash.isEqual)(action.path, ["surveyor"]) || (0, import_lodash.isEqual)(action.path, ["teamId"]))) {
    const surveyor = parentEnv.getAbsoluteAs(["surveyor"], import_types.isUserRef).getOrNull();
    const teamId = parentEnv.getAbsoluteAs(["teamId"], import_types.isTeamId).getOrNull();
    const messages = state.field.rule(parentEnv);
    const counts = (0, import_message.messageCounts)(messages);
    return {
      ...state,
      surveyor,
      teamId,
      messages,
      ...counts,
      highlight: (0, import_message.messageHighlight)(counts)
    };
  } else {
    return state;
  }
}
function primaryTeamFieldReducer(state, parentEnv, action) {
  if (action.type === "Change" && ((0, import_lodash.isEqual)(action.path, ["surveyor"]) || (0, import_lodash.isEqual)(action.path, ["teamId"]))) {
    const surveyor = parentEnv.getAbsoluteAs(["surveyor"], import_types.isUserRef).getOrNull();
    const teamId = parentEnv.getAbsoluteAs(["teamId"], import_types.isTeamId).getOrNull();
    const messages = state.field.rule(parentEnv);
    const counts = (0, import_message.messageCounts)(messages);
    return {
      ...state,
      surveyor,
      teamId,
      messages,
      ...counts,
      highlight: (0, import_message.messageHighlight)(counts)
    };
  } else {
    return state;
  }
}
function contentReducer(state, parentEnv, action) {
  switch (state.type) {
    case "CardState":
      return cardReducer(state, parentEnv, action);
    case "DynamicValueState":
      return dynamicValueReducer(state, parentEnv, action);
    case "DynamicGridState":
      return dynamicGridReducer(state, parentEnv, action);
    case "DynamicImageState":
      return dynamicImageReducer(state, parentEnv, action);
    case "FullWidthState":
      return fullWidthReducer(state, parentEnv, action);
    case "HeadingState":
      return state;
    case "TextState":
      return textReducer(state, parentEnv, action);
    case "GroupState":
      return gridReducer(state, parentEnv, action);
    case "RepeatState":
      return repeatReducer(state, parentEnv, action);
    case "RequireRoleState":
      return requireRoleReducer(state, parentEnv, action);
    case "ScopeState":
      return scopeReducer(state, parentEnv, action);
    case "VisibilityState":
      return visibilityReducer(state, parentEnv, action);
    case "PrimarySurveyorFieldState":
      return primarySurveyorFieldReducer(state, parentEnv, action);
    case "PrimaryTeamFieldState":
      return primaryTeamFieldReducer(state, parentEnv, action);
    default:
      return (0, import_util.checkExhausted)(state);
  }
}
function blockReducer(state, parentEnv, action) {
  if ((0, import_guard2.isFieldState)(state)) {
    return fieldReducer(state, parentEnv, action);
  } else {
    return contentReducer(state, parentEnv, action);
  }
}
function pageReducer(state, formEnv, action) {
  const { page, blockStates: blockStates0 } = state;
  const env = formEnv.focus(page.path);
  const blockStates = blockStates0.map((state2) => blockReducer(state2, env, action));
  const counts = (0, import_message.pageMessageCounts)(blockStates);
  const highlight = (0, import_message.messageHighlight)(counts);
  const enabled = (0, import_run.optTopoEval)(page.enabled, env).getOrUndefined() ?? true;
  return { ...state, blockStates, highlight, enabled, ...counts };
}
function formReducer(state, action) {
  if (action.type === "Reset") {
    return (0, import_initial.initialFormState)(action.form, action.schema, action.document);
  } else {
    const { document: survey0, pageStates: pageStates0 } = state;
    let env;
    switch (action.type) {
      case "Change": {
        env = import_topo_core.Env.create(survey0).setAbsolute(action.path, action.value).getOrThrow();
        break;
      }
      case "Insert": {
        env = import_topo_core.Env.create(survey0).updateAbsoluteAs(import_guard.isArray, action.path, (array) => [...array, ...action.values]).getOrThrow();
        break;
      }
      case "Delete": {
        env = import_topo_core.Env.create(survey0).updateAbsoluteAs(import_guard.isArray, action.path, (array) => [
          ...array.slice(0, action.index),
          ...array.slice(action.index + 1)
        ]).getOrThrow();
        break;
      }
      default:
        (0, import_util.checkExhausted)(action);
    }
    const pageStates = pageStates0.map((ps) => pageReducer(ps, env, action));
    const errorCount = pageStates.reduce((total, pageState) => total + pageState.errorCount, 0);
    const infoCount = pageStates.reduce((total, pageState) => total + pageState.infoCount, 0);
    const document = env.doc();
    return { ...state, document, pageStates, errorCount, infoCount };
  }
}
function formStateDocument(state, guard, hint) {
  return import_fp.Result.pure(state.document).guard(guard, hint);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  blockReducer,
  cardReducer,
  contentReducer,
  dynamicGridReducer,
  dynamicImageReducer,
  dynamicValueReducer,
  fieldReducer,
  formReducer,
  formStateDocument,
  fullWidthReducer,
  gridReducer,
  pageReducer,
  primarySurveyorFieldReducer,
  primaryTeamFieldReducer,
  repeatReducer,
  requireRoleReducer,
  scopeReducer,
  textReducer,
  visibilityReducer
});
//# sourceMappingURL=reducer.js.map
